import { createAsyncThunk } from "@reduxjs/toolkit";

import coreAPIs from "../../services/api/core";

export const validateContentIngestion = createAsyncThunk(
  "contentIngestion/validateContentIngestion",
  async (payload, { rejectWithValue }) => {
    try {
      const response = await coreAPIs.validateContentIngestion(payload);

      return response.data;
    } catch (error) {
      return rejectWithValue(error.response.data);
    }
  },
);

export const processContentIngestion = createAsyncThunk("contentIngestion/processContentIngestion", async (payload) => {
  try {
    const response = await coreAPIs.processContentIngestion(payload);

    return response.data;
  } catch (error) {
    console.error(error);
    throw error;
  }
});

export const listAllContentIngestion = createAsyncThunk("contentIngestion/listAllContentIngestion", async (payload) => {
  try {
    const response = await coreAPIs.listAllContentIngestion(payload);

    return response.data;
  } catch (error) {
    console.error(error);
    throw error;
  }
});

export const cancelContentIngestion = createAsyncThunk("contentIngestion/cancelContentIngestion", async (payload) => {
  try {
    const response = await coreAPIs.cancelContentIngestion(payload);

    return response.data;
  } catch (error) {
    console.error(error);
    throw error;
  }
});
